<div class="container-fluid d-flex p-0">
    <app-side-bar></app-side-bar>

    <ng-container>
        <div style="padding: 15px; margin: 5px; width: -webkit-fill-available;">
            <div class="main-heading">
                <h1>Section Wise Email</h1>
            </div>

            <!-- TOP ROW (Dropdown styled like date input) -->
            <div class="top-row">
                <div class="section-picker">
                    <select class="section-dd" [(ngModel)]="selectedSection" (change)="onSectionChange()">
                        <option value="IP">IP</option>
                    </select>
                    <span class="section-dd-caret">▾</span>
                </div>

                 <div class="subject-box" style="min-width:320px; flex:1; margin:0 12px;">
    <input
      type="text"
      class="form-control"
      placeholder="Enter email subject"
      [(ngModel)]="subject"
    />
  </div>

                <div class="actions">
                    <button class="btn btn-primary" (click)="openPreviewDialog()">View Template</button>
                </div>
            </div>

            <!-- EMAIL BUILDER (Header + Editor + Footer) -->
            <div class="email-builder">
                <!-- Header (fixed image) -->
                <!-- <div class="email-header">
                    <img [src]="headerImagePath" alt="Header" class="email-header-img" />
                </div> -->

                <!-- CKEditor Body -->
                <div class="email-body-editor">
                    <ckeditor [editor]="Editor" [(ngModel)]="bodyHtml" (ready)="onEditorReady($event)"
                        (change)="onBodyChange()">
                    </ckeditor>
                </div>

                <!-- Footer (fixed) -->
                <!-- <div class="email-footer">
                    <div class="footer-regards">By regards</div>
                    <div class="footer-brand">PharSights Info</div>
                </div> -->
            </div>
        </div>
    </ng-container>

    <!-- PREVIEW DIALOG -->
    <p-dialog [(visible)]="isDialogVisible" [modal]="true" [header]="'Email Template Preview'" [closable]="true"
        [dismissableMask]="true" [style]="{ width: '70vw' }">

        <div class="p-dialog-content">
            <!-- ✅ proper preview container -->
            <div class="preview-wrapper">
                <div class="preview-card">
                    <div class="preview-content" [innerHTML]="sanitizeHtml(previewHtml)"></div>
                </div>
            </div>

        </div>

        <p-footer>
            <!-- ✅ Send mail inside dialog -->
            <button type="button" class="btn btn-success" (click)="sendMailFromDialog()" [disabled]="isSendingMail">
                {{ isSendingMail ? 'Sending...' : 'Send Mail' }}
            </button>

            <button type="button" class="btn btn-secondary" (click)="isDialogVisible = false">
                Close
            </button>
        </p-footer>
    </p-dialog>
</div>